"use strict";
import React from "react";
export default React.createClass({
  render: function() {
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        "data-component": "NotificationCtaButton",
        className: "button--link-v2 button-small mb-0",
        onClick: this.props.onClick
      },
      this.props.children
    );
  }
});
